module.exports = __webpack_public_path__ + "static/img/qr_formulario_tribunal_diciplina.fa4d583.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paginaoficial/qr_formulario_tribunal_diciplina.jpeg
// module id = M4el
// module chunks = 2